import LoadImages from '../_utils/LoadImages';

const TOTAL_FRAMES = 105;

export default class Challenge2030 {


	// Constructor
	constructor(asscroll, element) {
		this.asscroll = asscroll;
		this.element = element;

		this.container = this.element.querySelector('.section-2030-challenge--scroll');
		this.fixed = this.element.querySelector('.section-2030-challenge--fixed');
		this.imageContainer = this.element.querySelector('.section-2030-challenge--image');
		this.textContainer = this.element.querySelector('.section-2030-challenge--text');

		this.imageContainer.innerHTML = '';

		this.animationIsLoaded = false;
		this.canvas = document.createElement('canvas');
		this.context = this.canvas.getContext('2d');
		this.images = [];
		this.percent = 0;

		this.imagesLoaded = this.imagesLoaded.bind(this);
		this.scroll = this.scroll.bind(this);

		const files = [];
		const baseUrl = document.body.getAttribute('data-theme-url');
		for (var i=0, l=TOTAL_FRAMES; i<=l; i++) {
			files.push(`${baseUrl}assets/img/2030-challenge/${i.toString().padStart(4, '0')}.png`);
		}

		new LoadImages(files, this.imagesLoaded);

	}


	// Public Methods
	destroy() {
		this.disable();
		delete this.animationIsLoaded;
		delete this.asscroll;
		delete this.canvas;
		delete this.container;
		delete this.context;
		delete this.element;
		delete this.fixed;
		delete this.imageContainer;
		delete this.images;
		delete this.percent;
		delete this.textContainer;
	}
	enable() {
		this.asscroll.on('update', this.scroll);
	}
	disable() {
		this.asscroll.off('update', this.scroll);
	}


	// Event Handlers
	imagesLoaded(images) {
		this.images = images;

		this.canvas.width = this.images[0].width;
		this.canvas.height = this.images[0].height;

		this.updateImage();


		this.imageContainer.appendChild(this.canvas);

		this.animationIsLoaded = true;
	}
	scroll({ currentPos }) {
		let { top } = this.container.getBoundingClientRect();
		const elementHeight = this.container.offsetHeight;
		const windowHeight = window.innerHeight;
		let height = windowHeight - elementHeight;
		this.percent = Math.min(1, Math.max(0, top / height));

		if (window.innerWidth < 768) {
			const offset = windowHeight * 0.3;
			top -= offset;
			height = elementHeight - offset;
			this.percent = Math.min(1, Math.max(0, -top / height));
		}

		this.updateImage();

		this.textContainer.style.transform = `translate3d(0, ${this.percent * -80}%, 0)`;

		const steps = 4;
		const step = Math.floor(steps * this.percent);
		for (let i=0, l=steps+1; i<l; i++) {
			if (i === step) {
				this.element.classList.add('on-item-' + i);
			} else {
				this.element.classList.remove('on-item-' + i);
			}
		}

		if (top <= height) {
			this.element.classList.add('is-bottom');
			this.element.classList.remove('is-sticky');
			this.fixed.style.transform = 'translate3d(0, 0, 0)';
		} else if (top <= 0) {
			this.element.classList.remove('is-bottom');
			this.element.classList.add('is-sticky');
			this.fixed.style.transform = `translate3d(0, ${currentPos}px, 0)`;
		} else {
			this.element.classList.remove('is-bottom');
			this.element.classList.remove('is-sticky');
			this.fixed.style.transform = 'translate3d(0, 0, 0)';
		}

	}

	// Helpers
	updateImage() {
		if (this.animationIsLoaded) {
			const index = Math.floor((this.images.length - 1) * this.percent);
			this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
			this.context.drawImage(this.images[index], 0, 0);
		}
	}


}
